<template>
  <div class="countDetail__wrap">
    <el-dialog
      :title="title"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      append-to-body
      @close-before="handleClose"
      width="1050px"
    >
      <div style="height: 400px">
        <ioc-table
          ref="crud"
          :data="tableData"
          :option="option"
          :page="page"
          @search-change="handleSearchChange"
          @search-reset="handleSearchReset"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
          <template :slot="tableFileList[0]" slot-scope="scope">
            <img
              v-if="scope.row[tableFileList[0]]"
              :src="getImgPath(scope.row[tableFileList[0]].split('|')[0])"
              @click="showViewer(scope.row[tableFileList[0]].split('|'))"
              onerror="this.src='/images/theme/newDark/default.png'"
              style="height: 25px; width: 50px; cursor: pointer"
            />
          </template>
          <template :slot="queryFlag != '' ? 'menu' : ''" slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              v-if="scope.row.processResult == 1"
              content="处理"
              placement="top"
              popper-class="tooltip-draw"
            >
              <el-button
                type="text"
                icon="el-icon-s-check"
                @click="handleDeal(scope.row, scope.index)"
              ></el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              v-if="scope.row.processResult == 0"
              content="详情"
              placement="top"
              popper-class="tooltip-draw"
            >
              <el-button
                type="text"
                icon="iconfont icon-Detail"
                @click="handleView(scope.row, scope.index)"
              ></el-button>
            </el-tooltip>
          </template>
        </ioc-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">关闭</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="dealTitle"
      :visible.sync="dialogDeal"
      append-to-body
      :close-on-click-modal="false"
      @close-before="handleCloseDeal"
      width="600px"
    >
      <div>
        <div class="dialog-list">
          <div v-if="processResult == 0" class="dealInfo">
            <div class="item">
              <div class="label">处理人：{{ dealInfo.modifierName }}</div>
              <div class="label">工号：{{ dealInfo.modifier }}</div>
            </div>
            <div class="item">
              <div class="label">电话：{{ dealInfo.phone }}</div>
              <div class="label">部门：{{ dealInfo.deptName }}</div>
            </div>
            <div class="item">
              <div class="label">处理时间：{{ dealInfo.modifyTime }}</div>
            </div>
          </div>
          <div
            v-for="item in exception"
            :key="item.firePatrolItemCode"
            class="deal"
          >
            <div class="item">
              <div class="label tip">{{ item.firePatrolItemName }}：</div>
              <span style="color: #f56c6c">
                {{ item.firePatrolItemValue }}
              </span>
            </div>
            <div class="item">
              <div class="label">处理结果：</div>
              <div v-if="processResult == 0">
                {{ item.processResult | dic("SENU11103") }}
              </div>
              <el-select
                v-else
                v-model="item.processResult"
                placeholder="请选择"
              >
                <el-option
                  v-for="i in dealList"
                  :key="i.value"
                  :label="i.label"
                  :value="i.value"
                >
                </el-option>
              </el-select>
              <div class="errorTip" v-if="item.processResult === null">
                * 请选择处理结果
              </div>
            </div>
            <div class="item">
              <div class="label">处理描述：</div>
              <div v-if="processResult == 0">{{ item.processDesc }}</div>
              <div style="width: 90%" v-else>
                <el-input
                  style=""
                  type="textarea"
                  v-model="item.processDesc"
                  :autosize="{ minRows: 2, maxRows: 5 }"
                  placeholder="请输入描述"
                >
                </el-input>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="handleCloseDeal" :loading="dealLoading">
          {{ dealLoading ? "提交中" : "取消" }}
        </el-button>
        <el-button
          type="primary"
          v-if="processResult == 1"
          @click="handleConfirmDeal"
          :loading="dealLoading"
          >{{ dealLoading ? "提交中" : "确定" }}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Dic, Bus } from "$utils";
import { api } from "../api";
import utils from "@src/common/utils";
import tableOption from "../config/countDetail";
export default {
  props: {
    title: {
      type: String,
      default: "防火巡查明细",
    },
  },
  data() {
    return {
      processResult: 0, //0 解决，1 未解决
      dealList: Dic.find("SENU11103"),
      dialogDeal: false,
      dealLoading: false,
      dealTitle: "巡检异常项处理",
      queryFlag: "", //exception
      firePatrolCode: "",
      dialogVisible: false,
      option: tableOption(this),
      optionCopy: tableOption(this),
      tableData: [],
      exception: [],
      dealInfo: {},
      tableFileList: [],
      page: {
        pageNum: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
    };
  },
  created() {},
  methods: {
    showViewer(list) {
      let src = list.map((el) => {
        return this.getImgPath(el);
      });
      this.$app.AppInstance.handleShowViewer(src);
    },
    getImgPath(item) {
      return item ? Bus.imgPath(item) : "";
    },
    handleCloseDeal() {
      this.dialogDeal = false;
      this.exception = [];
    },
    handleConfirmDeal() {
      let isDeal = this.exception.some((el) => {
        return el.processResult === null;
      });
      if (isDeal) {
        return;
      }
      this.dealLoading = true;
      let params = {
        firePatrolRecordCode: this.exception[0].firePatrolRecordCode,
        firePatrolRecordDetailList: this.exception.map((el) => {
          return {
            processDesc: el.processDesc,
            processResult: el.processResult,
            firePatrolItemCode: el.firePatrolItemCode,
          };
        }),
      };

      this.$fetch(api.updateFirePatrolRecordList, params).then((response) => {
        this.dealLoading = false;
        if (response.success) {
          this.$message.success("操作成功");
          this.getList();
          this.$emit("handleUpdate");
          this.handleCloseDeal();
        } else {
          this.$message.error(response.msgContent || "获取巡检项列表失败");
        }
      });

      this.dialogDeal = false;
    },
    handleClose() {
      this.dialogVisible = false;
      this.tableData = [];
    },
    handleDeal(row) {
      console.log(row);
      this.processResult = row.processResult;
      this.exception = [...row.firePatrolRecordDetailList];
      this.dialogDeal = true;
    },
    handleView(row) {
      this.dealTitle = "巡检异常处理详情";
      this.processResult = row.processResult;
      this.exception = [...row.firePatrolRecordDetailList];
      this.dealInfo = { ...row };
      this.dialogDeal = true;
    },
    handleSearchChange(param) {
      this.searchForm = { ...param };
      this.getList();
    },
    handleSearchReset() {
      this.searchForm = {};
      this.getList();
    },
    handleSizeChange(val) {
      this.page.pageNum = 1;
      this.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page.pageNum = val;
      this.getList();
    },
    getReset() {
      this.page.pageNum = 1;
      this.page.pageSize = 10;
      this.getList();
    },
    getList() {
      this.tableFileList = [];
      let params = {
        firePatrolCode: this.firePatrolCode,
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
      };
      if (this.queryFlag) {
        params.queryFlag = this.queryFlag;
      }
      this.$fetch(api.getFirePatrolRecordList, params).then((response) => {
        if (response.success) {
          let list = response.returnObj.list;
          this.tableData = list.map((el) => {
            el.firePatrolRecordDetailList.forEach((item) => {
              if (item.type == 5) {
                this.tableFileList.push(item.firePatrolItemCode);
              }
              el[item.firePatrolItemCode] = item.firePatrolItemValue;
            });
            return el;
          });
          this.page.total = response.returnObj ? response.returnObj.total : 0;
        } else {
          this.$message.error(response.msgContent || "获取巡检项列表失败");
        }
      });
    },
    getDetail() {
      let tableOption = [];
      this.$fetch(api.detailFirePatrolItems, {
        firePatrolCode: this.firePatrolCode,
      }).then((res) => {
        if (res.success) {
          tableOption = res.returnObj.firePatrolItemList.map((el) => {
            return {
              label: el.firePatrolItemName,
              prop: el.firePatrolItemCode,
            };
          });
        }
        console.log(tableOption);
        this.option.column = this.optionCopy.column.concat(tableOption);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-list {
  // margin: 16px;
  max-height: 500px;
  overflow: auto;
  .dealInfo {
    display: flex;
    flex-direction: column;
    .label {
      width: 50%;
    }
  }
  .deal {
    display: flex;
    flex-direction: column;
  }
  .item {
    display: flex;
    margin: 12px 0;
    align-items: center;
    .label {
      min-width: 80px;
      padding-left: 10px;
    }
    .tip {
      // margin: 10px 0 16px 10px;
      border-left: 5px solid #407aee;
      // padding-left: 10px;
      font-size: 14px;
      color: #e8eaee;
    }
    .errorTip {
      color: #f56c6c;
      font-size: 12px;
      line-height: 1;
      margin-left: 10px;
    }
  }
}
.countDetail {
  &__wrap {
  }
}
</style>